import * as Yup from 'yup';
import { compareSemverVersions } from '../lib/compareSemverVersions';
import { SEMVER_REGEX } from './system';



export const targetValidationNullable = (values) => {
  const targetValues = values?.target ? values?.target : {
    min_version: values?.min_version ?? null,
    max_version: values?.max_version ?? null,
    platform: values?.platform ?? null,
    countries: values?.countries ?? null,
    languages: values?.languages ?? null,
  };

  return {
    min_version: Yup.string()
      .nullable()
      .matches(SEMVER_REGEX, 'Min version has incorrect format. Try semantic version like 1.0 or 1.0.0')
      .test(
        'check-min-version',
        'Min version should be less than or equal to the max version',
        (value) => {
          const maxValue = targetValues?.max_version;

          if (value && maxValue) {
            return compareSemverVersions(value, maxValue) || value === maxValue;
          }

          return true;
        },
      ),
    max_version: Yup.string()
      .nullable()
      .matches(SEMVER_REGEX, 'Max version has incorrect format. Try semantic version like 1.0 or 1.0.0')
      .test(
        'check-max-version',
        'Max version should be greater than or equal to the min version',
        (value) => {
          const minValue = targetValues?.min_version;

          if (value && minValue) {
            return compareSemverVersions(minValue, value) || value === minValue;
          }

          return true;
        },
      ),
    platform: Yup.array().of(Yup.string()).nullable(),
    countries: Yup.array().of(Yup.string()).nullable(),
    languages: Yup.array().of(Yup.string()).nullable(),
  };
};
